export default __webpack_public_path__ + "img/ng100.4e1ff462.jpg";